export default __webpack_public_path__ + "static/mh-logo-2x-912ebdb5e2169f2638da0921541dbdbf.png";